/* Shine & Style — mobile behaviour.
 *
 * Deliberately small. The sticky buy bar is already shown and
 * hidden by ss-premium.js and its price is already followed by
 * ss-variants.js; a second observer on the same class would only
 * fight the first. This file adds the two things neither does.
 */
(function () {
  'use strict';

  /* The buy bar is fixed to the bottom of the viewport, so on a
     product page the last rows of content sat underneath it with
     no way to scroll clear.

     The reserved height is measured rather than written down: the
     bar is two lines of copy beside a button, and that copy is
     longer in Arabic than in English, so any fixed number is wrong
     in one language or the other. Re-measured on resize because
     rotating the phone rewraps it.  */
  var buybar = document.querySelector('[data-buybar]');
  if (buybar) {
    document.body.classList.add('ss-has-buybar');

    var reserve = function () {
      document.body.style.setProperty(
        '--ss-buybar-h', Math.ceil(buybar.getBoundingClientRect().height) + 'px');
    };
    reserve();

    /* Watching the bar rather than the window. Measuring once on
       load reads the height before the webfont swaps in and before
       a long button label rewraps, and lands a few pixels short -
       which is exactly the gap that hides the last line of the
       page. A ResizeObserver catches every one of those. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(reserve).observe(buybar);
    } else {
      window.addEventListener('resize', reserve, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserve);
    }
  }

  /* An empty bag has nothing to report. The count is written from
     two other scripts, so rather than teach both about the empty
     case, watch the badge and derive it here. */
  var count = document.querySelector('[data-cart-count]');
  if (count) {
    var sync = function () {
      count.classList.toggle('is-empty', (parseInt(count.textContent, 10) || 0) === 0);
    };
    sync();
    if ('MutationObserver' in window) {
      new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
    }
  }

  /* The header is pinned, so it no longer takes up space in the
     flow - the page has to reserve it instead. Measured rather
     than written down: the announcement bar wraps differently
     between languages and the row is shorter on a phone, so any
     fixed number is wrong somewhere. */
  var group = document.getElementById('header-group');
  if (group) {
    var reserveHeader = function () {
      document.documentElement.style.setProperty(
        '--ss-headergroup-h', Math.ceil(group.getBoundingClientRect().height) + 'px');
    };
    reserveHeader();
    if ('ResizeObserver' in window) {
      new ResizeObserver(reserveHeader).observe(group);
    } else {
      window.addEventListener('resize', reserveHeader, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(reserveHeader);
    }
  }

  /* Header state. A scroll listener rather than an observer,
     because the threshold is the header's own offset and that
     moves with the announcement bar. */
  var header = document.querySelector('.ss-header');
  if (header) {
    var ticking = false;
    var update = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }
})();
